/**
 * Project: Aniatek
 * Author: Carlos A. Loaiza | Connect & Launch
 * Tel: +52 (667) 247 - 6316
 * Intellectual Property: All rights reserved (c) 2026
 */
 
<template>
  <ModalExito v-show="mostrarExito" :mostrarExito="mostrarExito" />
  <ModalConfirmacion v-if="mostrarModalConfirmacion" @confirmar="eliminarUsuario" @cancelar="cancelarEliminacion"
    :nombreUsuario="nombreCliente" />
  <LoadScreen v-if="mostrarLoaderDos" />
  <LayoutPrincipal>
    <ContainerWhite>
      <div style="height: 100%;">
        <section class="filtrosEmpleados">
          <div class="tituloModulo">Módulo Administradores</div>
          <div class="buscadorYagregar">
            <input class="inputBuscador" type="text" v-model="searchText" placeholder="Buscar por nombre" />
            <Button class="btn-agregar" @click="mostrarAddService">Agregar</Button>
          </div>
        </section>
        <section class="tabla-con-loader">
          <div class="tabla-scrollable">
            <table class="default">
              <thead>
                <tr class="cabecera">
                  <th>ID</th>
                  <th>Nombre Completo</th>
                  <th>Rol</th>
                  <th class="desktop-only">Correo</th>
                  <th class="desktop-only">Telefono</th>
                  <th class="desktop-only">Fecha de Registro</th>
                  <th class="desktop-only">Contraseña</th>
                  <th class="desktop-only">Acciones</th>
                  <th class="mobile-only" style="width: 50px;">Ver</th>
                </tr>
              </thead>
              <tbody class="tbody">
                <tr v-if="mostrarLoader" class="fila-loader">
                  <td colspan="10" class="loader-wrapper">
                    <LoadScreenModal class="loader-solo" />
                  </td>
                </tr>
                <tr v-else-if="filteredList.length === 0">
                  <td colspan="10" class="mensajeNoResultados">No se encontraron resultados</td>
                </tr>
                <template v-else v-for="cliente in filteredList" :key="cliente.id_usuario">
                  <tr :class="{ 'fila-activa': isExpanded(cliente.id_usuario) }">
                    <td>
                      <span class="folio-text">{{ String(cliente.id_usuario).padStart(3, '0') }}</span>
                    </td>
                    <td class="nombre-celda">
                      {{ capitalizeWords(cliente.nombre) + ' ' + capitalizeWords(cliente.ape_pat) + ' ' + capitalizeWords(cliente.ape_mat) }}
                    </td>
                    <td>
                      <span class="rol-badge">{{ cliente.rol.nombre }}</span>
                    </td>
                    <td class="desktop-only">{{ cliente.correo }}</td>
                    <td class="desktop-only">{{ cliente.telefono }}</td>
                    <td class="desktop-only">{{ formatarFecha(cliente.fecha_registro) }}</td>
                    <td class="desktop-only">*****</td>
                    <td class="desktop-only">
                      <div class="botonesTabla">
                        <template v-if="!isSuperAdmin(cliente)">
                          <Button class="btn-editar" @click="mostrarEditarCliente(cliente)" title="Editar cliente">
                            <i class="fa-solid fa-pen-to-square"></i>
                          </Button>
                          <Button class="btn-eliminar" @click="eliminarClienteConfirmacion(cliente)"
                            title="Eliminar cliente">
                            <i class="fa-solid fa-trash"></i>
                          </Button>
                        </template>
                        <span v-else title="Protegido" style="color: #64748b; font-size: 1.2rem;">
                          <i class="fa-solid fa-shield-halved"></i>
                        </span>
                      </div>
                    </td>
                    <td class="mobile-only">
                      <button class="btn-toggle" @click="toggleRow(cliente.id_usuario)">
                        <i
                          :class="isExpanded(cliente.id_usuario) ? 'fa-solid fa-chevron-up' : 'fa-solid fa-chevron-down'"></i>
                      </button>
                    </td>
                  </tr>
                  <tr v-if="isExpanded(cliente.id_usuario)" class="mobile-detail-row">
                    <td colspan="4" class="detail-cell">
                      <div class="detalle-wrapper">
                        <div class="info-grid">
                          <div class="info-item">
                            <span class="label">Correo</span>
                            <span class="value">{{ cliente.correo }}</span>
                          </div>
                          <div class="info-item">
                            <span class="label">Teléfono</span>
                            <span class="value">{{ cliente.telefono }}</span>
                          </div>
                          <div class="info-item">
                            <span class="label">Registro</span>
                            <span class="value">{{ formatarFecha(cliente.fecha_registro) }}</span>
                          </div>
                        </div>
                        <div class="botonesTabla mobile-actions">
                          <Button class="btn-editar" @click="mostrarEditarCliente(cliente)">
                            <i class="fa-solid fa-pen-to-square"></i>
                          </Button>
                          <Button class="btn-eliminar" @click="eliminarClienteConfirmacion(cliente)">
                            <i class="fa-solid fa-trash"></i>
                          </Button>
                        </div>
                      </div>
                    </td>
                  </tr>
                </template>
              </tbody>
            </table>
          </div>
        </section>
      </div>
    </ContainerWhite>
    <AgregarAdministrador v-if="mostrarModal" @cancelar="mostrarModal = false"
      @actualizado="handleClienteActualizado" />
    <EditarAdministrador v-if="mostrarModalEditar" :admin="clienteSeleccionado" @cancelar="mostrarModalEditar = false"
      @actualizado="handleClienteActualizado" />
    <Paginacion class="paginacion-fija" :paginaActualEntrada="currentPage" :total="totalPages"
      @changePagina="changePage" />
    <div v-if="mostrarModalCotizacion" class="modal-cotizacion-overlay"></div>
  </LayoutPrincipal>
</template>

<script setup>
import { ref, onMounted, computed, watch } from 'vue';
import AdminService from '../services/adminService.js'
import LayoutPrincipal from "../layouts/layoutPrincipal.vue";
import ContainerWhite from "../layouts/ContainerWhite.vue";
import Button from "../components/Forms/Button.vue";
import Paginacion from "../components/Forms/Paginacion.vue";
import AgregarAdministrador from "../components/Administrador/AgregarAdministrador.vue";
import EditarAdministrador from "../components/Administrador/EditarAdministrador.vue";
import ModalExito from '../components/Modales/ModalExito.vue';
import ModalConfirmacion from '../components/Modales/ModalConfirmacion.vue';
import LoadScreenModal from "../components/Forms/LoadScreenModal.vue";
import LoadScreen from '../components/Forms/LoadScreen.vue';
import userService from '@/services/userService.js';
import { isSuperAdmin } from '@/utils/acciones.js';

const mostrarLoader = ref(false);
const clientes = ref([]);
const searchText = ref('');
const mostrarExito = ref(false);
const mostrarModalConfirmacion = ref(false);
const nombreCliente = ref('');
const mostrarLoaderDos = ref(false);
const mostrarModal = ref(false);
const mostrarModalEditar = ref(false);
const clienteSeleccionado = ref(null);
const mostrarModalCotizacion = ref(false);
const expandedRows = ref([]);
const itemsPerPage = ref(10);
const currentPage = ref(1);

const fetchClientes = async () => {
  mostrarLoader.value = true;
  try {
    const rolesDeseados = [1, 3];
    const response = await userService.getUsersByRol(rolesDeseados.join(','));
    clientes.value = response.data;
  } catch (err) {
    console.error("Error al cargar clientes:", err);
  } finally {
    mostrarLoader.value = false;
  }
};

onMounted(fetchClientes);

const filteredAndSortedList = computed(() => {
  let listaFiltrada = clientes.value;
  if (searchText.value) {
    const search = searchText.value.toLowerCase();
    listaFiltrada = listaFiltrada.filter(cliente => {
      const nombreCompleto = `${cliente.nombre || ''} ${cliente.ape_pat || ''} ${cliente.ape_mat || ''}`.toLowerCase();
      return (
        (cliente.id_usuario && cliente.id_usuario.toString().includes(search)) ||
        nombreCompleto.includes(search)
      );
    });
  }
  return [...listaFiltrada].sort((a, b) => {
    return a.id_usuario - b.id_usuario;
  });
});

const totalPages = computed(() => {
  return Math.ceil(filteredAndSortedList.value.length / itemsPerPage.value);
});

const filteredList = computed(() => {
  const listaCompleta = filteredAndSortedList.value;
  const start = (currentPage.value - 1) * itemsPerPage.value;
  const end = start + itemsPerPage.value;
  return listaCompleta.slice(start, end);
});

const changePage = (page) => {
  if (page >= 1 && page <= totalPages.value) {
    currentPage.value = page;
  }
};

watch(searchText, () => {
  currentPage.value = 1;
});

const capitalizeWords = (str) => {
  if (!str) return '';
  return str
    .toLowerCase()
    .split(' ')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
};

const toggleRow = (id) => {
  if (expandedRows.value.includes(id)) {
    expandedRows.value = expandedRows.value.filter(rowId => rowId !== id);
  } else {
    expandedRows.value.push(id);
  }
};

const isExpanded = (id) => {
  return expandedRows.value.includes(id);
};

const mostrarAddService = () => {
  mostrarModal.value = true;
};

const handleClienteActualizado = async () => {
  mostrarModalEditar.value = false;
  mostrarModal.value = false;
  mostrarExito.value = true;
  setTimeout(() => { mostrarExito.value = false; }, 2000);
  await fetchClientes();
};

const mostrarEditarCliente = (cliente) => {
  clienteSeleccionado.value = { ...cliente };
  mostrarModalEditar.value = true;
};

const eliminarClienteConfirmacion = (cliente) => {
  clienteSeleccionado.value = cliente;
  nombreCliente.value = `${cliente.nombre} ${cliente.ape_pat} ${cliente.ape_mat || ''}`.trim();
  mostrarModalConfirmacion.value = true;
};

const cancelarEliminacion = () => {
  mostrarModalConfirmacion.value = false;
  clienteSeleccionado.value = null;
  nombreCliente.value = '';
};

const eliminarUsuario = async () => {
  if (!clienteSeleccionado.value) return;

  mostrarModalConfirmacion.value = false;
  mostrarLoaderDos.value = true;

  try {
    const idParaEliminar = clienteSeleccionado.value.id_usuario;
    await AdminService.deleteAdmin(idParaEliminar);

    clientes.value = clientes.value.filter(
      cliente => cliente.id_usuario !== idParaEliminar
    );

    mostrarExito.value = true;
    setTimeout(() => { mostrarExito.value = false; }, 2000);

  } catch (error) {
    console.error("Error al eliminar el cliente:", error);
  } finally {
    mostrarLoaderDos.value = false;
    clienteSeleccionado.value = null;
    nombreCliente.value = '';
  }
};

const formatarFecha = (fechaISO) => {
  if (!fechaISO) return 'N/A';
  const fecha = new Date(fechaISO);
  const opciones = { day: '2-digit', month: '2-digit', year: 'numeric' };
  return fecha.toLocaleDateString('es-MX', opciones);
};
</script>

<style scoped>
.filtrosEmpleados {
  justify-content: space-between;
  display: flex;
  padding: 20px 20px 20px 50px;
  align-items: center;
}

.tituloModulo {
  font-size: 25px;
  color: #2a428c;
  font-weight: bolder;
  font-style: italic;
}

.buscadorYagregar {
  display: flex;
  align-items: center;
}

.inputBuscador {
  width: 300px;
  height: 42px;
  max-width: 250px;
  margin-right: 0;
  z-index: 10;
  border: 1px solid #cbd5e1;
  border-radius: 8px;
  padding: 0 15px;
  font-size: 14px;
  transition: border-color 0.3s, box-shadow 0.3s;
  margin-right: 20px;
}

.inputBuscador:focus {
  outline: none;
  border-color: #29b9f6;
  box-shadow: 0 0 0 3px rgba(47, 141, 183, 0.2);
}

.tablaPrincipal {
  width: 100%;
  overflow-x: auto;
  overflow-x: hidden;
}

.default {
  border-collapse: collapse;
  width: 100%;
  box-shadow: 0px 3px 6px #00000029;
}

.cabecera {
  background: black;
  color: white;
  height: 50px;
}

.default td,
.default th {
  border: none;
  padding: 15px 12px;
  text-align: center;
}

.default tr:nth-child(even) {
  background-color: #f8fafc;
}

.default th {
  background-color: black;
  color: #fff;
  font-size: 16px;
  letter-spacing: 1px;
}

.tbody {
  font-size: 14.5px;
}

.mensajeNoResultados {
  text-align: center;
  font-size: 16px;
  font-weight: bold;
  color: #691c32;
  padding: 20px 0;
}

.paginacion-fija {
  margin-top: auto;
}

.tabla-con-loader {
  position: relative;
}

.fila-loader {
  position: relative;
  height: 58vh;
}

.tabla-scrollable {
  max-height: 72vh;
  overflow-y: auto;
  background: white;
}

table {
  width: 100%;
  border-collapse: collapse;
}

thead th {
  position: sticky;
  top: 0;
  background-color: #000;
  color: white;
  z-index: 10;
}

.modal-cotizacion-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.mobile-only {
  display: none;
}

.mobile-detail-row {
  display: none;
}

@media (max-width: 810px) {

  .buscadorYagregar {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .desktop-only {
    display: none;
  }

  .mobile-only {
    display: table-cell;
    vertical-align: middle;
  }

  .tituloModulo {
    font-size: 25px;
    margin-bottom: 15px;
  }

  .filtrosEmpleados {
    padding: 20px;
    display: flex;
    flex-direction: column;
  }

  .inputBuscador {
    width: 50%;
    max-width: 250px;
    margin-right: 0;
    z-index: 10;
    border: 1px solid #cbd5e1;
    border-radius: 8px;
    padding: 0 15px;
    font-size: 14px;
    transition: border-color 0.3s, box-shadow 0.3s;
  }

  .default {
    table-layout: auto;
  }

  .default th {
    font-size: 14px;
    letter-spacing: 0;
    padding: 10px 4px;
  }

  .default td {
    padding: 12px 5px;
    font-size: 13px;
    vertical-align: middle;
  }

  .nombre-celda {
    font-weight: 600;
    color: #333;
    line-height: 1.2;
  }

  .rol-badge {
    display: inline-block;
    background-color: #f1f1f1;
    border-radius: 4px;
    padding: 2px 6px;
    font-size: 11px;
    color: #555;
  }

  .btn-toggle {
    background: transparent;
    border: none;
    font-size: 18px;
    color: #29b9f6;
    cursor: pointer;
    padding: 8px;
    transition: transform 0.2s;
  }

  .fila-activa {
    background-color: #fff8f5 !important;
    border-bottom: 2px solid #29b9f6;
  }

  .mobile-detail-row {
    display: table-row;
    animation: fadeIn 0.3s ease-out;
  }

  .default tr.mobile-detail-row,
  .default tr.mobile-detail-row:nth-child(even),
  .default tr.mobile-detail-row:nth-child(odd) {
    background-color: #fafafa;
    box-shadow: inset 0px 5px 10px -5px rgba(0, 0, 0, 0.1);
  }

  .detail-cell {
    padding: 0 !important;
  }

  .detalle-wrapper {
    padding: 20px 15px;
  }

  .info-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 15px;
    margin-bottom: 20px;
    text-align: left;
  }

  .info-item {
    display: flex;
    flex-direction: column;
  }

  .info-item.full-width {
    grid-column: span 2;
  }

  .label {
    font-size: 11px;
    color: #888;
    text-transform: uppercase;
    font-weight: bold;
    margin-bottom: 3px;
  }

  .value {
    font-size: 14px;
    color: #222;
    word-break: break-word;
  }

  .mobile-actions {
    display: flex;
    justify-content: center;
    gap: 15px;
    padding-top: 10px;
    border-top: 1px solid #e0e0e0;
  }

  .mobile-actions .btn-editar,
  .mobile-actions .btn-eliminar {
    width: 35px;
    height: 35px;
    font-size: 16px;
    border-radius: 50px;
  }
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(-5px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>